export default function updateDataCenterReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_DATA_CENTER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_DATA_CENTER_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_DATA_CENTER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}